module.exports = __webpack_public_path__ + "static/media/version_control_light.94683fce.svg";